import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { fetchJornada } from "../services/trackingServiceV2";
import { toast } from "react-toastify";
import JornadaTimeline from "../components/JornadaTimeline";

// Página cheia da Jornada do Cliente (/tracking/jornada/:visitorId). Mesmo conteúdo do popup.

export default function JornadaCliente() {
    const { isOpen } = useContext(SidebarContext);
    const { visitorId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => { loadJornada(); }, [visitorId]);

    async function loadJornada() {
        setLoading(true);
        try {
            setData(await fetchJornada(visitorId));
        } catch {
            toast.error("Erro ao buscar jornada");
        }
        setLoading(false);
    }

    return (
        <div className="min-h-screen bg-surface-1 text-white flex">
            <main className={`transition-all duration-300 ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full p-6 mb-16 sm:mb-0`}>
                <header className="mb-6">
                    <button onClick={() => navigate(-1)} className="text-ink-3 hover:text-white text-sm mb-3 inline-flex items-center gap-1">← Voltar</button>
                    <h1 className="text-3xl font-bold">Jornada do Cliente</h1>
                    <p className="text-sm text-ink-3 mt-1">Tudo que essa pessoa fez nas suas páginas, do primeiro acesso até hoje, com as compras no meio do caminho.</p>
                </header>

                {loading && <div className="flex justify-center py-12"><div className="w-8 h-8 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin" /></div>}
                {data && !loading && <JornadaTimeline data={data} visitorId={visitorId} />}
            </main>
        </div>
    );
}
